import { createContext } from "react";

const HomeModal = createContext( null );
const ActiveLoansModal = createContext( null );
const ClosedLoansModal = createContext( null );
const ListsModal = createContext( null );
const HeaderModal = createContext( null );
const ModalCtx = createContext( null );
const ObjModal = createContext( null );
const CommsPanelCtx = createContext( null );


export { HomeModal, ActiveLoansModal, ClosedLoansModal, ListsModal, HeaderModal, ModalCtx, ObjModal, CommsPanelCtx };